import { isDefined, logStdout } from "../../shared/utils";
import fileSys from "../../fileoprators/fileSystem";
import { cartesian2polar, FILES, isDataValid, MAJMEDIANMODES } from "../../topography/shared";
import TopographyRecordProc from "../../topography/js/TopographyRecordProc";
import DataParams from "../../topography/dataGetters/params";
import { normalMapValues } from "../../topography/dataGetters/mapValues";
import { paramNormal } from "../../shared/filters";
import path from "path";
const request = require("request");
const { exec, spawn } = window.require("child_process");
const moment = require("moment");

let topographyRecordProc = new TopographyRecordProc();
const fs = window.require("fs");
var Iconv = window.require("iconv-lite");
var Json2csvParser = window.require("json2csv").Parser;

// 导出地址
// 存储选中类型
var exportType = "";
// 存储选中干眼类型
var exportTypeImageVideo = "";
// 存储选中角膜类型
var exportTypeTopography = [];
// 存储角膜和干眼数据
let recordAllDetails = "";
// 存储os od
var arrOsOd = ["OS", "OD"];
// 目录路径
var getMediaPath = fileSys.getUploadPath("");

// 最后返回干眼和角膜的路径
var callbackPath = {
  osPath: "",
  odPath: ""
};
// 最后返回角膜四象图的路径
var callbackTopographyImagePath = "";
// 获取角膜原图
var topographyOriginalObj = {};
// 存储拷贝数据
var copyArr = [];
var usbName = "";

class ExportData {
  constructor(e) {
    this.checkPatients = [];
    // 暂时保存表格数据
    this.saveUserDryeyeTable = [];
    // 存储干眼表格title
    this.saveUserTableFields = [
      "Name",
      "Pid",
      "CheckTime",
      "EYE",
      "Nibut_First_Rupture_Time",
      "Nibut_AVG_Rupture_Time",
      "TearHeight_Auto",
      "TearHeight_Manual",
      "TearHeight_TearArea",
      "LipidLayer_Level",
      "Meibomian_Up_GlandRatio",
      "Meibomian_Up_GlandLoss",
      "Meibomian_Up_Score",
      "Meibomian_Down_GlandRatio",
      "Meibomian_Down_GlandLoss",
      "Meibomian_Down_Score",
      "EyelidEdge_Up_Score",
      "EyelidEdge_Down_Score",
      "EyelidEdge_Note",
      "EyeRedness_CiliaryCongestion",
      "EyeRedness_ConjunctivalCongestion",
      "EyeRedness_Note",
      "Surface_Note"
    ];
    // 暂时保存表格数据
    this.saveUserTopographyTable = [];
    // 存储角膜表格title
    this.saveUserTopographyTableFields = [
      "Name",
      "Pid",
      "CheckTime",
      "EYE",
      "K1",
      "Rh",
      "Rf",
      "K2",
      "Rv",
      "Rs",
      "Km",
      "Rm",
      "Astig",
      "ecc",
      "E",
      "P_val",
      "Q",
      "Kmax",
      "Rmin",
      "Pupil_Diameter",
      "Pupil_Diameter_X",
      "Pupil_Diameter_Y",
      "Cornea_Diameter",
      "Cornea_Center_X",
      "Cornea_Center_Y"
    ];
    // 干眼和角膜的根目录
    this.rootPath = {};
    //  干眼是否有表格或报告
    this.hasDryeyeTable = false;
    this.hasDryeyeReport = false;
    // 角膜是否有原图 角膜图 报告 表格
    this.hasTopographyOriginalImage = false;
    this.hasTopographyImage = false;
    this.hasTopographyReport = false;
    this.hasTopographyOriginaTable = false;
    this.hasTopographyEye = false;
    this.hasTopographyMwf = false;
    this.hasTopograPhy = false;
    this.hasDryeye = false;
    this.dataOrg = {
      pupildia: {
        x: -1000,
        y: -1000,
        r: -1000
      },
      corneadia: {
        x: -1000,
        y: -1000,
        r: -1000
      }
    };
    this.dataInForm = {
      pupildia: {
        x: "--",
        y: "--",
        r: "--"
      },
      corneadia: {
        x: "--",
        y: "--",
        r: "--"
      }
    };
    // 存储路径内容
    this.getPathArr = [];
    //  u 盘名称变量
    this.Udisk = "/home/mw520/Udisk";
  }

  // 存储已选值
  patientCheckAll(patients) {
    this.checkPatients.push(patients);
  }

  // 单个数组去重
  removeSame(data) {
    for (let i = 0; i < data.length; i++) {
      for (let j = i + 1; j < data.length; j++) {
        if (data[i]._id === data[j]._id) {
          data.splice(i, 1);
          j--;
        }
      }
    }
    return data;
  }

  // 多个数组去重 勾选全部
  removeSamePatients(data, pNoCheckAllArr) {
    if (data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < pNoCheckAllArr.length; j++) {
          if (data[i]._id === pNoCheckAllArr[j]._id) {
            data.splice(i, 1);
          }
        }
      }
    }
    return data;
  }

  // 获取未选中的病人列表
  getNoCheckPaList(rows, patientsData) {
    let pNoCheckCurrentArr = [];
    // true就是选中，0或者false是取消选中
    for (let i = 0; i < patientsData.length; i++) {
      let flag = false;
      for (let j = 0; j < rows.length; j++) {
        if (patientsData[i]._id === rows[j]._id) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        pNoCheckCurrentArr.push(patientsData[i]);
      }
    }
    return pNoCheckCurrentArr;
  }

  //  导出表格数据
  exportTableData(callback) {
    let dryEyePath;
    let topographyPath;
    if (this.saveUserDryeyeTable.length > 0 && this.saveUserTopographyTable.length > 0) {
      // dryEyePath = this.rootPath.dryEye + 'dryEyeTable.csv'
      dryEyePath =
        this.rootPath.dryEye +
        moment(Math.round(new Date())).format("YYYY_MM_DD_HH_mm_ss") +
        "_" +
        "dryEyeTable.csv";
      // topographyPath = this.rootPath.topography + 'topographyTable.csv'
      topographyPath =
        this.rootPath.topography +
        moment(Math.round(new Date())).format("YYYY_MM_DD_HH_mm_ss") +
        "_" +
        "topographyTable.csv";
      let _this = this;
      _this.writeTableFile(dryEyePath, "dryEye", function (type) {
        if (type) {
          _this.writeTableFile(topographyPath, "topography", function (type) {
            if (type) {
              callback(type);
            }
          });
        }
      });
    } else if (this.saveUserDryeyeTable.length > 0 || this.saveUserTopographyTable.length > 0) {
      let path;
      let tableType;
      if (this.saveUserDryeyeTable.length > 0) {
        // path = this.rootPath.dryEye + 'dryEyeTable.csv'
        path =
          this.rootPath.dryEye +
          moment(Math.round(new Date())).format("YYYY_MM_DD_HH_mm_ss") +
          "_" +
          "dryEyeTable.csv";
        tableType = "dryEye";
      }
      if (this.saveUserTopographyTable.length > 0) {
        // path = this.rootPath.topography + 'topographyTable.csv'
        path =
          this.rootPath.topography +
          moment(Math.round(new Date())).format("YYYY_MM_DD_HH_mm_ss") +
          "_" +
          "topographyTable.csv";
        tableType = "topography";
      }
      this.writeTableFile(path, tableType, function (type) {
        if (type) {
          callback(type);
        }
      });
    } else {
      const type = true;
      callback(type);
    }
  }

  // 抽离表格存储方法
  writeTableFile(path, tableType, callback) {
    let csv;
    let json2csv;
    let saveUserTableFields;
    let saveUserTableData;
    if (tableType === "dryEye") {
      saveUserTableFields = this.saveUserTableFields;
      saveUserTableData = this.saveUserDryeyeTable;
    } else {
      saveUserTableFields = this.saveUserTopographyTableFields;
      saveUserTableData = this.saveUserTopographyTable;
    }
    json2csv = new Json2csvParser({ saveUserTableFields, excelStrings: false });
    csv = json2csv.parse(saveUserTableData);
    // let newCsv = Iconv.encode(csv, 'GBK')
    let newCsv = Iconv.encode(csv, "UTF8");
    fs.writeFile(path, newCsv, { encoding: "utf8" }, function (err) {
      let type;
      if (err) {
        type = false;
      } else {
        type = true;
      }
      callback(type);
    });
  }

  //  存储表格数据
  saveTableData(record, currentPatient) {
    if (record.hasOwnProperty("eyetype")) {
      let eyeType = record.eyetype.toString();
      if (eyeType.indexOf("OS") !== -1 && eyeType.indexOf("OD") === -1) {
        if (!record.content.dataOS.hasOwnProperty("topography")) {
          this.tableName(record.content.dataOS, record.recorddate, currentPatient, "OS");
        }
      }
      if (eyeType.indexOf("OD") !== -1 && eyeType.indexOf("OS") === -1) {
        if (!record.content.dataOD.hasOwnProperty("topography")) {
          this.tableName(record.content.dataOD, record.recorddate, currentPatient, "OD");
        }
      }
      if (eyeType.indexOf("OS") !== -1 && eyeType.indexOf("OD") !== -1) {
        if (
          !record.content.dataOS.hasOwnProperty("topography") &&
          !record.content.dataOD.hasOwnProperty("topography")
        ) {
          this.tableName(record.content.dataOS, record.recorddate, currentPatient, "OS");
          this.tableName(record.content.dataOD, record.recorddate, currentPatient, "OD");
        }
      }
    }
  }

  // 选项判断 是否有报告和表格等
  hasReportTableFun(exportType) {
    this.hasTopograPhy = false;
    this.hasDryeyeReport = false;
    this.hasDryeyeTable = false;
    this.hasTopographyOriginaTable = false;
    this.hasTopographyEye = false;
    this.hasTopographyMwf = false;
    this.hasTopographyReport = false;
    this.hasTopographyOriginalImage = false;
    this.hasTopographyImage = false;
    this.hasDryeye = false;
    logStdout("export data exportType", exportType.dryEye);
    for (let i = 0; i < exportType.dryEye.length; i++) {
      if (exportType.dryEye[i].value === "Table") {
        this.hasDryeyeTable = true;
        this.hasDryeye = true;
      }
      if (exportType.dryEye[i].value === "Report") {
        this.hasDryeyeReport = true;
        this.hasDryeye = true;
      }
      if (exportType.dryEye[i].hasOwnProperty("imageVideo")) {
        if (exportType.dryEye[i].imageVideo.length > 0) {
          this.hasDryeye = true;
        }
      }
    }
    for (let i = 0; i < exportType.Topography.length; i++) {
      if (exportType.Topography[i].value === "Table") {
        this.hasTopographyOriginaTable = true;
        this.hasTopograPhy = true;
      }
      if (exportType.Topography[i].value === "Report") {
        this.hasTopographyReport = true;
        this.hasTopograPhy = true;
      }
      if (exportType.Topography[i].value === "Original Photo") {
        this.hasTopographyOriginalImage = true;
        this.hasTopograPhy = true;
      }
      if (exportType.Topography[i].value === "Corneal topography") {
        this.hasTopographyImage = true;
        this.hasTopograPhy = true;
      }
      if (exportType.Topography[i].value === "eye") {
        this.hasTopographyEye = true;
        this.hasTopograPhy = true;
      }
      if (exportType.Topography[i].value === "mwf") {
        this.hasTopographyMwf = true;
        this.hasTopograPhy = true;
      }
    }
  }

  // 合并路径
  getNowPath(originalPath, nowPath) {
    if (originalPath && nowPath) {
      return path.join(originalPath, nowPath);
    } else {
      return null;
    }
    // return (originalPath + nowPath)
  }

  // ---------------------------
  // 干眼数据格式
  // 泪河面积
  tearAreaAuto(tearheight) {
    const autocalcarea = tearheight.autocalcarea;
    let deal = autocalcarea * Math.pow(window.magecoe.tearheight, 2);
    if (!isDefined(autocalcarea) || autocalcarea === -1) {
      return "--";
    } else {
      return deal.toFixed(2) + "mm^2";
    }
  }

  // 计算Meibomian 等级
  getGlandLoss(glandloss) {
    const glandlossVal = glandloss === 0 ? 0 : Math.floor(glandloss * 1000) / 10;
    const val =
      glandlossVal === 0
        ? 0
        : glandlossVal > 0 && glandlossVal <= 33
          ? 1
          : glandlossVal > 33 && glandlossVal <= 66
            ? 2
            : 3;
    return val;
  }

  tableName(record, recordDate, currentPatient, eyeType) {
    let table = {
      Name: "",
      Pid: "",
      CheckTime: "",
      EYE: "",
      Nibut_First_Rupture_Time: "",
      Nibut_AVG_Rupture_Time: "",
      TearHeight_Auto: "",
      TearHeight_Manual: "",
      TearHeight_TearArea: "",
      LipidLayer_Level: "",
      Meibomian_Up_GlandRatio: "",
      Meibomian_Up_GlandLoss: "",
      Meibomian_Up_Score: "",
      Meibomian_Down_GlandRatio: "",
      Meibomian_Down_GlandLoss: "",
      Meibomian_Down_Score: "",
      EyelidEdge_Up_Score: "",
      EyelidEdge_Down_Score: "",
      EyelidEdge_Note: "",
      EyeRedness_CiliaryCongestion_N: "",
      EyeRedness_CiliaryCongestion_T: "",
      EyeRedness_ConjunctivalCongestion_N: "",
      EyeRedness_ConjunctivalCongestion_T: "",
      EyeRedness_Note: "",
      Surface_Note: ""
    };
    if (record) {
      let trensdDataYHeigth;
      let curTearHeight;
      let tearHeightAuto;
      let tearArea;
      if (record.hasOwnProperty("tearheight")) {
        if (record.tearheight.hasOwnProperty("trensdDataYHeigth")) {
          trensdDataYHeigth = record.tearheight.trensdDataYHeigth;
        }
        if (record.tearheight.hasOwnProperty("clonetrensdDataYHeigth")) {
          trensdDataYHeigth = record.tearheight.clonetrensdDataYHeigth;
        }
        if (
          !record.tearheight.hasOwnProperty("trensdDataYHeigth") &&
          !record.tearheight.hasOwnProperty("clonetrensdDataYHeigth")
        ) {
          trensdDataYHeigth = undefined;
        }
        curTearHeight =
          isDefined(record.tearheight.manualMeasureAvg) && record.tearheight["manualMeasureAvg"] > 0
            ? Math.round(record.tearheight.manualMeasureAvg * 100) / 100
            : undefined;
        tearHeightAuto =
          trensdDataYHeigth === undefined || trensdDataYHeigth === null || trensdDataYHeigth < 0
            ? undefined
            : window.magecoe.tearheight * trensdDataYHeigth;
        tearArea = this.tearAreaAuto(record.tearheight);
      }
      const name =
        currentPatient.firstname && currentPatient.firstname.lastname
          ? currentPatient.firstname + "_" + currentPatient.lastname
          : currentPatient.firstname;
      let LipidLevel;
      if (record.hasOwnProperty("lipidlayer") && record.lipidlayer.hasOwnProperty("level")) {
        if (record.lipidlayer.level === 1) {
          LipidLevel = "1" + "(<30 nm)";
        } else if (record.lipidlayer.level === 2) {
          LipidLevel = "2" + "(30 - 60 nm)";
        } else if (record.lipidlayer.level === 3) {
          LipidLevel = "3" + "(60 - 80 nm)";
        } else if (record.lipidlayer.level === 4) {
          LipidLevel = "4" + "(>80 nm)";
        }
      }
      let eyelidUpLevel;
      if (record.hasOwnProperty("eyelidedge") && record.eyelidedge.hasOwnProperty("up")) {
        if (record.eyelidedge.up.level === "1") {
          eyelidUpLevel = "1" + "(Normal)";
        } else if (record.eyelidedge.up.level === "1") {
          eyelidUpLevel = "2" + "(Mild)";
        } else if (record.eyelidedge.up.level === "3") {
          eyelidUpLevel = "3" + "(Moderate)";
        } else if (record.eyelidedge.up.level === "4") {
          eyelidUpLevel = "4" + "(Severe)";
        }
      }
      let eyelidDownLevel;
      if (record.hasOwnProperty("eyelidedge") && record.eyelidedge.hasOwnProperty("down")) {
        if (record.eyelidedge.down.level === "1") {
          eyelidDownLevel = "1" + "(Normal)";
        } else if (record.eyelidedge.down.level === "2") {
          eyelidDownLevel = "2" + "(Mild)";
        } else if (record.eyelidedge.down.level === "3") {
          eyelidDownLevel = "3" + "(Moderate)";
        } else if (record.eyelidedge.down.level === "4") {
          eyelidDownLevel = "4" + "(Severe)";
        }
      }
      let firstrupturetime = "";
      let firstavgruptrure = "";
      if (record.hasOwnProperty("nibut") && record.nibut.hasOwnProperty("firstrupturetime")) {
        if (record.nibut.firstrupturetime >= 10000) {
          firstrupturetime = record.nibut.usefultime
            ? `>${record.nibut.usefultime.toFixed(1)}s`
            : ">21s";
        } else {
          firstrupturetime = record.nibut.firstrupturetime.toFixed(2) + "s";
        }
      } else {
        firstrupturetime = "";
      }

      if (record.hasOwnProperty("nibut") && record.nibut.hasOwnProperty("avgruptruretime")) {
        if (record.nibut.avgruptruretime >= 10000) {
          firstavgruptrure = record.nibut.usefultime
            ? `>${record.nibut.usefultime.toFixed(1)}s`
            : ">21s";
        } else {
          firstavgruptrure = record.nibut.avgruptruretime.toFixed(2) + "s";
        }
      } else {
        firstavgruptrure = "";
      }
      table.Name = name;
      table.Pid = currentPatient.pid;
      table.CheckTime = recordDate;
      table.EYE = eyeType;
      table.Nibut_First_Rupture_Time = firstrupturetime || "--";
      table.Nibut_AVG_Rupture_Time = firstavgruptrure || "--";
      table.TearHeight_Auto = tearHeightAuto ? tearHeightAuto.toFixed(2) + "mm" : "--";
      table.TearHeight_Manual = curTearHeight !== undefined ? curTearHeight + "mm" : "--";
      table.TearHeight_TearArea = tearArea;
      table.LipidLayer_Level = LipidLevel;

      if (record.hasOwnProperty("meibomian") && record.meibomian.hasOwnProperty("up")) {
        table.Meibomian_Up_GlandRatio =
          record.meibomian.up.glandpercent === 0
            ? 0
            : Math.floor(record.meibomian.up.glandpercent * 1000) / 10 + "%";
        table.Meibomian_Up_GlandLoss =
          record.meibomian.up.glandloss === 0
            ? 0
            : Math.floor(record.meibomian.up.glandloss * 1000) / 10 + "%";
        table.Meibomian_Up_Score = record.meibomian.up.gland_grade;
        table.Meibomian_Up_Score = this.getGlandLoss(record.meibomian.up.glandloss);
      }
      if (record.hasOwnProperty("meibomian") && record.meibomian.hasOwnProperty("down")) {
        table.Meibomian_Down_GlandRatio =
          record.meibomian.down.glandpercent === 0
            ? 0
            : Math.floor(record.meibomian.down.glandpercent * 1000) / 10 + "%";
        table.Meibomian_Down_GlandLoss =
          record.meibomian.down.glandloss === 0
            ? 0
            : Math.floor(record.meibomian.down.glandloss * 1000) / 10 + "%";
        // table.Meibomian_Down_Score = record.meibomian.down.gland_grade
        table.Meibomian_Down_Score = this.getGlandLoss(record.meibomian.down.glandloss);
      }
      table.EyelidEdge_Up_Score = eyelidUpLevel;
      table.EyelidEdge_Down_Score = eyelidDownLevel;
      table.EyelidEdge_Note =
        record.hasOwnProperty("eyelidedge") && record.eyelidedge.hasOwnProperty("note")
          ? record.eyelidedge.note
          : "--";
      table.EyeRedness_CiliaryCongestion_N =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("nasalciliary")
          ? record.eyeredness.nasalciliary.toFixed(2)
          : "--";
      table.EyeRedness_CiliaryCongestion_T =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("tempciliary")
          ? record.eyeredness.tempciliary.toFixed(2)
          : "--";
      table.EyeRedness_ConjunctivalCongestion_N =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("nasalconjunctival")
          ? record.eyeredness.nasalconjunctival.toFixed(2)
          : "--";
      table.EyeRedness_ConjunctivalCongestion_T =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("tempconjunctival")
          ? record.eyeredness.tempconjunctival.toFixed(2)
          : "--";
      table.EyeRedness_Note =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("note")
          ? record.eyeredness.note
          : "--";
      table.Surface_Note =
        record.hasOwnProperty("ocularsurface") && record.ocularsurface.hasOwnProperty("note")
          ? record.ocularsurface.note
          : "--";
      this.saveUserDryeyeTable.push(table);
    }
  }

  //  ----------角膜---------
  //  获取角膜原图
  getTopographyOriginImage(detailsMyself, eyeType, dataShowSettings, hasCasePath, callback) {
    let obj = {
      largeImgUrl: "",
      mapValues: ""
    };
    let _this = this;
    if (hasCasePath) {
      _this.topographyReportFun(obj.largeImgUrl, eyeType, dataShowSettings, function (mapValues) {
        if (mapValues) {
          _this.topographyMapValues = mapValues;
          obj.largeImgUrl = obj.largeImgUrl.replace(/\\/g, "/");
          obj.mapValues = mapValues;
          obj.casePath = obj.largeImgUrl;
          callback(obj);
        }
      });
    } else {
      try {
        topographyRecordProc
          .getRecord(detailsMyself, eyeType)
          .then(function (url) {
            let largeImgUrl = "";
            largeImgUrl = fileSys.combinePath(url, FILES.originImage);
            // largeImgUrl 改为 url
            _this.topographyReportFun(url, eyeType, dataShowSettings, function (mapValues) {
              if (mapValues) {
                _this.topographyMapValues = mapValues;
                obj.largeImgUrl = largeImgUrl.replace(/\\/g, "/");
                obj.mapValues = mapValues;
                obj.casePath = url;
                callback(obj);
              }
            });
          })
          .catch((e) => {
            console.log("--err--", e);
            obj.largeImgUrl = "";
            obj.mapValues = "";
            obj.casePath = "";
            callback(obj, e);
          });
      } catch (e) {
        console.log("--err--", e);
        obj.largeImgUrl = "";
        obj.mapValues = "";
        obj.casePath = "";
        callback(obj, e);
      }
    }
  }

  //  获取瞳孔原图
  getPupilOriginImage(photos) {
    const { serverip, serverport, sslport, serverssl } = window.server || {};
    let protocol = serverssl === 1 ? "https:" : "http:";
    let port = serverssl === 1 ? sslport : serverport;
    let photo = photos[0];
    let img = isDefined(photo)
      ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}`
      : "";
    return img;
  }

  topographyReportFun(casePath, eyeType, dataShowSettings, callback) {
    const dataParams = new DataParams(casePath);
    const mapValues = normalMapValues(
      dataParams,
      eyeType,
      dataShowSettings.medianMode,
      dataShowSettings.mm
    );
    callback(mapValues);
  }

  // 角膜表格数据格式
  saveTopographyTableData(mapValues, record, currentPatient, topographyOriginal, dataShowSettings) {
    let eyeType = topographyOriginal.eyeType;
    // 判断是否有瞳孔 或 角膜
    let hasPupildia =
      record.content[`data${eyeType}`] &&
      record.content[`data${eyeType}`].hasOwnProperty("pupilcorneadia") &&
      record.content[`data${eyeType}`].pupilcorneadia.pupildia;
    let hasCorneadia =
      record.content[`data${eyeType}`] &&
      record.content[`data${eyeType}`].hasOwnProperty("pupilcorneadia") &&
      record.content[`data${eyeType}`].pupilcorneadia.corneadia;
    let table = {
      Name: "--",
      Pid: "--",
      CheckTime: "--",
      EYE: "--",
      K1: "--",
      K2: "--",
      Km: "--",
      Rm: "--",
      Astig: "--",
      ecc: "--",
      E: "--",
      P_val: "--",
      Q: "--",
      Rh: "--",
      Rf: "--",
      Rv: "--",
      Rs: "--",
      Kmax: "--",
      Rmin: "--",
      Pupil_Diameter: "--",
      Pupil_Center_X: "--",
      Pupil_Center_Y: "--",
      Cornea_Diameter: "--",
      Cornea_Center_X: "--",
      Cornea_Center_Y: "--"
    };
    const name =
      currentPatient.firstname && currentPatient.firstname.lastname
        ? currentPatient.firstname + "_" + currentPatient.lastname
        : currentPatient.firstname;
    table.Name = name;
    table.Pid = currentPatient.pid;
    table.CheckTime = record.recorddate;
    table.EYE = eyeType;
    // 获取瞳孔数值
    let coe = window.magecoe.pupilcornea;
    let edgeMoved;
    let edge;
    if (hasPupildia) {
      edgeMoved = record.content[`data${eyeType}`].pupilcorneadia.pupildia.edgeMoved;
      edge =
        isDefined(edgeMoved) && isDataValid(edgeMoved.r) && edgeMoved.r > 0
          ? edgeMoved
          : record.content[`data${eyeType}`].pupilcorneadia.pupildia.edge;
    }
    // 获取角膜数值
    let corneaeEdgeMoved;
    let corneaeEdge;
    if (hasCorneadia) {
      corneaeEdgeMoved = record.content[`data${eyeType}`].pupilcorneadia.corneadia.edgeMoved;
      corneaeEdge =
        isDefined(corneaeEdgeMoved) && isDataValid(corneaeEdgeMoved.r) && corneaeEdgeMoved.r > 0
          ? corneaeEdgeMoved
          : record.content[`data${eyeType}`].pupilcorneadia.corneadia.edge;
    }
    // 计算
    if (topographyOriginal.hasPupilImgType) {
      if (record.content[`data${eyeType}`].pupilcorneadia.pupildia.hasOwnProperty("edge")) {
        if (hasPupildia) {
          this.initEdge("pupildia", record.content[`data${eyeType}`].pupilcorneadia.pupildia.edge);
        }
        if (hasCorneadia) {
          this.initEdge("corneadia", record.content[`data${eyeType}`].pupilcorneadia.pupildia.edge);
        }
        if (hasPupildia) {
          table.Pupil_Diameter = (edge.r * 2 * coe).toFixed(2) + "mm";
          table.Pupil_Center_X = (edge.x * coe).toFixed(2) + "mm";
          table.Pupil_Center_Y = (edge.y * coe).toFixed(2) + "mm";
        }
        if (hasCorneadia) {
          table.Cornea_Diameter = (corneaeEdge.r * 2 * coe).toFixed(2) + "mm";
          table.Cornea_Center_X = (corneaeEdge.x * coe).toFixed(2) + "mm";
          table.Cornea_Center_Y = (corneaeEdge.y * coe).toFixed(2) + "mm";
        }
      }
    }
    table.K1 = this.getParamK1Val(mapValues.params, dataShowSettings);
    table.K2 = this.getParamK2Val(mapValues.params, dataShowSettings);
    table.Km = this.getParamKmVal(mapValues.params);
    table.Rm = this.getParamRmVal(mapValues.params);
    table.Rf =
      this.RhRfTitle(dataShowSettings) === "Rf"
        ? this.getRf(mapValues.params, dataShowSettings)
        : "--";
    table.Rh =
      this.RhRfTitle(dataShowSettings) === "Rh"
        ? this.getRh(mapValues.params, dataShowSettings)
        : "--";
    table.Rv =
      this.RvRsTitle(dataShowSettings) === "Rv"
        ? this.getRv(mapValues.params, dataShowSettings)
        : "--";
    table.Rs =
      this.RvRsTitle(dataShowSettings) === "Rs"
        ? this.getRs(mapValues.params, dataShowSettings)
        : "--";
    table.Kmax = this.getParamKmaxVal(mapValues.params, dataShowSettings);
    table.Rmin = this.getParamRminVal(mapValues.params, dataShowSettings);
    table.Astig = this.getParamAstigVal(mapValues.params);
    const eccTitle = this.eccPEQTitle(dataShowSettings);
    if (eccTitle.title2 === "ecc") {
      table.ecc = this.getParamEccPEQVal(mapValues.params);
    } else if (eccTitle.title2 === "E") {
      table.E = this.getParamEccPEQVal(mapValues.params);
    } else if (eccTitle.title2 === "P_val") {
      table.P_val = this.getParamEccPEQVal(mapValues.params);
    } else if (eccTitle.title2 === "Q") {
      table.Q = this.getParamEccPEQVal(mapValues.params);
    }
    this.saveUserTopographyTable.push(table);
  }

  // 获得 k1 rh rf rv rs 的值
  getParamK1Val(params, dataShowSettings) {
    // return `${paramNormal(params['K1'].value)}D @ ${paramNormal(params['AxisFlat'].value)}° / ${this.getRhRf(params, dataShowSettings)}mm`
    return `${paramNormal(params["K1"].value)}D @ ${paramNormal(params["AxisFlat"].value)} ` + "°";
  }

  // getRhRf (params, dataShowSettings) {
  //   return paramNormal(dataShowSettings.isRhRv ? params['Rh'].value + 'mm' : params['Rf'].value) + 'mm'
  // }
  getRh(params, dataShowSettings) {
    return paramNormal(params["Rh"].value + "mm");
  }

  getRf(params, dataShowSettings) {
    return paramNormal(params["Rf"].value + "mm");
  }

  RhRfTitle(dataShowSettings) {
    return dataShowSettings.isRhRv ? "Rh" : "Rf";
  }

  // getRvRs (params, dataShowSettings) {
  //   return paramNormal(dataShowSettings.isRhRv ? params['Rv'].value : params['Rs'].value)
  // }
  getRv(params, dataShowSettings) {
    return paramNormal(params["Rv"].value) + "mm";
  }

  getRs(params, dataShowSettings) {
    if (params["Rs"].value !== -1000) {
      return paramNormal(params["Rs"].value) + "mm";
    } else {
      return "--";
    }
  }

  RvRsTitle(dataShowSettings) {
    return dataShowSettings.isRhRv ? "Rv" : "Rs";
  }

  getParamK2Val(params, dataShowSettings) {
    // return `${paramNormal(params['K2'].value)}D @ ${paramNormal(params['AxisSteep'].value)}° / ${this.getRvRs(params, dataShowSettings)} mm`
    return `${paramNormal(params["K2"].value)}D @ ${paramNormal(params["AxisSteep"].value)} ` + "°";
  }

  // getParamKmVal (params) {
  //   return ` ${paramNormal(params['Km'].value)}D / ${paramNormal(params['Rm'].value)}mm `
  // }

  getParamKmVal(params) {
    // return ` ${paramNormal(params['Km'].value)}D / ${paramNormal(params['Rm'].value)}mm `
    return ` ${paramNormal(params["Km"].value)}D`;
  }

  getParamRmVal(params) {
    // return ` ${paramNormal(params['Km'].value)}D / ${paramNormal(params['Rm'].value)}mm `
    if (params["Rm"].value !== -1000) {
      return `${paramNormal(params["Rm"].value)}mm`;
    } else {
      return "--";
    }
  }

  // getParamKmaxVal (params, dataShowSettings) {
  //   return `${paramNormal(params['Kmax'].value)}D / ${paramNormal(params['Rmin'].value)}mm (${this.getCartesianPolar(dataShowSettings, params, 'RminX', 'RminY')})`
  // }
  getParamKmaxVal(params, dataShowSettings) {
    if (params["Kmax"].value !== -1000) {
      return `${paramNormal(params["Kmax"].value)}D (${this.getCartesianPolar(
        dataShowSettings,
        params,
        "RminX",
        "RminY"
      )})`;
    } else {
      return "--D (--mm, --mm)";
    }
  }

  getParamRminVal(params, dataShowSettings) {
    return `${paramNormal(params["Rmin"].value)}mm (${this.getCartesianPolar(
      dataShowSettings,
      params,
      "RminX",
      "RminY"
    )})`;
  }

  getParamAstigVal(params) {
    let astig = -1000;
    let axis = -1000;
    if (isDataValid(params["K1"].value) && isDataValid(params["K2"].value)) {
      astig = params["K1"].value - params["K2"].value;
    }
    if (isDataValid(params["AxisFlat"].value) && isDataValid(params["AxisSteep"].value)) {
      axis = params["AxisFlat"].value;
    }
    if (axis !== -1000 && axis !== -1000) {
      return paramNormal(astig) + "D /" + paramNormal(axis) + "°";
    } else {
      return "--";
    }
  }

  getCartesianPolar(dataShowSettings, params, keyX, keyY) {
    if (dataShowSettings.isCartesian) {
      return `${paramNormal(params[keyX].value)}mm, ${paramNormal(params[keyY].value)}mm`;
    } else {
      if (isDataValid(params[keyX].value) && isDataValid(params[keyY].value)) {
        let { dist, angle } = cartesian2polar(params[keyX].value, params[keyY].value);
        return (
          `${paramNormal(dist)}mm @ ${paramNormal(angle, {
            fixed: 0,
            rpText: "--"
          })} ` + "°"
        );
      } else {
        return `--mm @ --°`;
      }
    }
  }

  getParamEccPEQVal(params) {
    return `${paramNormal(params["EccPEQ"].value)}`;
  }

  eccPEQTitle(dataShowSettings) {
    let title = "ecc";
    let title2 = "ecc";
    let mode = dataShowSettings.medianMode;
    switch (mode) {
      case MAJMEDIANMODES.ecc:
        title = `ecc(${dataShowSettings.mm}mm):`;
        title2 = "ecc";
        break;
      case MAJMEDIANMODES.E:
        title = `E(${dataShowSettings.mm}mm):`;
        title2 = "E";
        break;
      case MAJMEDIANMODES.P:
        title = `P(${dataShowSettings.mm}mm):`;
        title2 = "P_val";
        break;
      case MAJMEDIANMODES.Q:
        title = `Q(${dataShowSettings.mm}mm):`;
        title2 = "Q";
        break;
      default:
        break;
    }
    return {
      title: title,
      title2: title2
    };
  }

  //  瞳孔计算
  initEdge(mode, edge) {
    let coe = window.magecoe.pupilcornea;
    this.dataOrg[mode].r = edge.r;
    this.dataOrg[mode].x = edge.x;
    this.dataOrg[mode].y = edge.y;
    if (isDefined(edge) && isDataValid(edge.r) && edge.r > 0) {
      this.dataInForm[mode].r = (edge.r * 2 * coe).toFixed(2);
      this.dataInForm[mode].x = (edge.x * coe).toFixed(2);
      this.dataInForm[mode].y = (edge.y * coe).toFixed(2);
    } else {
      this.dataInForm[mode].r = "--";
      this.dataInForm[mode].x = "--";
      this.dataInForm[mode].y = "--";
    }
  }

  //   瞳孔四象图拷贝 写入文件
  copyCorneaImage(fourMap, topographyPath, callback) {
    if (topographyPath) {
      // for (let val in fourMap['fourMap']) {
      //   console.log('val', val)
      //   console.log(fourMap.fourMap[val])
      //   console.log(fourMap.fourMap.fourMaps)
      //   if (fourMap.fourMap.hasOwnProperty(val)) {
      //     this.drawAndShareImage(fourMap.fourMap[val].map, fourMap.fourMap[val].numValsMap, function (base64Img) {
      //       const base64NumValsMap = base64Img.replace(/^data:image\/\w+;base64,/, '')
      //       console.log(base64NumValsMap)
      //       fs.writeFileSync(topographyPath + '/' + val + '.jpg', base64NumValsMap, 'base64')
      //     })
      //   }
      // }
      // 这是判断是否选中角膜图
      if (exportFileData.hasTopographyImage) {
        const fourMaps = fourMap.fourMap.fourMaps;
        for (let val in fourMaps) {
          if (fourMaps.hasOwnProperty(val)) {
            this.drawAndShareImage(
              fourMaps[val].map,
              fourMaps[val].numValsMap ? fourMaps[val].numValsMap : fourMaps[val].map,
              function (base64Img) {
                const base64NumValMap = base64Img.replace(/^data:image\/\w+;base64,/, "");
                fs.writeFileSync(topographyPath + "/" + val + ".jpg", base64NumValMap, "base64");
              }
            );
          }
        }
      }
      const type = true;
      callback(type);
    }
  }

  //  封装两张base64合成一张图
  drawAndShareImage(base641, base642, callback) {
    const canvas = document.createElement("canvas");
    // canvas.width = 350
    // canvas.height = 350
    canvas.width = 550;
    canvas.height = 550;
    const context = canvas.getContext("2d");
    context.rect(0, 0, canvas.width, canvas.height);
    context.fillStyle = "#fff";
    context.fill();
    const myImage = new Image();
    // myImage.src = "./img/a.jpg";    //背景图片  你自己本地的图片或者在线图片
    myImage.src = base641; // 背景图片  你自己本地的图片或者在线图片
    myImage.crossOrigin = "Anonymous";
    myImage.onload = function () {
      // context.drawImage(myImage, 0, 0, 350, 350)
      context.drawImage(myImage, 0, 0, 550, 550);
      // context.font = '60px Courier New'
      // context.fillText('我是文字', 350, 450)
      const myImage2 = new Image();
      // myImage2.src = './img/b.jpg' // 你自己本地的图片或者在线图片
      myImage2.src = base642;
      myImage2.crossOrigin = "Anonymous";
      myImage2.onload = function () {
        // context.drawImage(myImage2, 0, 0, 350, 350)
        context.drawImage(myImage2, 0, 0, 550, 550);
        const base64 = canvas.toDataURL("image/png"); // "image/png" 这里注意一下
        callback(base64);
      };
    };
  }

  //   --------------------下面是创建文件夹和拷贝干眼---------------------------
  exportPath(
    PATH,
    getExportRecords,
    patients,
    records,
    exportType2,
    recordAllDetails2,
    topographyOriginalObj2,
    callback
  ) {
    const exportPathFile = PATH;
    // const patients = patients
    // const records = records
    // const getExportRecords = getExportRecords
    exportType = exportType2;
    recordAllDetails = recordAllDetails2;
    topographyOriginalObj = topographyOriginalObj2;
    for (let i = 0; i < exportType.dryEye.length; i++) {
      if (exportType.dryEye[i].imageVideo) {
        exportTypeImageVideo = exportType.dryEye[i].imageVideo;
      }
    }
    exportTypeTopography = [];
    for (let i = 0; i < exportType.Topography.length; i++) {
      if (
        exportType.Topography[i].value === "Original Photo" ||
        exportType.Topography[i].value === "Corneal topography"
      ) {
        exportTypeTopography.push(exportType.Topography[i].value.replace(/\s+/g, "_"));
      }
    }
    var hasChildFiles = false;
    var rootDirectory = exportPathFile + "/dea520";
    var dryEye = exportPathFile + "/dea520/" + "dryEye";
    var topography = exportPathFile + "/dea520/" + "topography";
    var hasRootDirectory = fileSys.isFileExists(rootDirectory);
    var hasDryEye = fileSys.isFileExists(dryEye);
    var topographyExists = fileSys.isFileExists(topography);

    if (!hasRootDirectory) {
      hasChildFiles = false;
      fileSys.mkdirSync(rootDirectory);
      hasChildFiles = true;
    }
    if (!hasDryEye && this.hasDryeye) {
      hasChildFiles = false;
      fileSys.mkdirSync(dryEye);
      hasChildFiles = true;
    } else if (hasDryEye && this.hasDryeye) {
      hasChildFiles = true;
    }

    let needTopography =
      this.hasTopograPhy &&
      (this.hasTopographyOriginaTable ||
        this.hasTopographyReport ||
        this.hasTopographyOriginalImage ||
        this.hasTopographyImage);
    if (!topographyExists && needTopography) {
      hasChildFiles = false;
      fileSys.mkdirSync(topography);
      hasChildFiles = true;
    } else if (topographyExists && needTopography) {
      hasChildFiles = true;
    }
    if (hasRootDirectory && hasDryEye && topographyExists) {
      hasChildFiles = true;
    }

    // console.log('upload文件内容', getPathArr)
    let _this = this;
    if (hasChildFiles) {
      _this.createInitFile(
        patients,
        getExportRecords,
        records,
        dryEye,
        topography,
        exportType,
        function (type) {
          _this.copyDryEye(0, function (type) {
            if (type) {
              copyArr = [];
              let msg = {
                type: 1,
                callbackPath: callbackPath,
                callbackTopographyImagePath: callbackTopographyImagePath,
                rootPath: {
                  dryEye: exportType.dryEye.length > 0 ? path.join(dryEye, "/") : null,
                  topography: exportType.Topography.length > 0 ? path.join(topography, "/") : null
                }
              };
              let data = {
                obj: msg
              };
              callback(data);
            }
          });
        }
      );
    } else {
      const msg = {
        type: 0,
        msg: {
          type: 0,
          message: "falied"
        }
      };
      callback(msg);
    }
  }
  // 初始新建干眼和角膜的文件夹
  createInitFile(patients, getExportRecords, records, dryEye, topography, exportType, callback) {
    let callType = false;
    let _this = this;
    if (_this.hasDryeye && !_this.hasTopograPhy) {
      this.createNameIdFiles(
        patients,
        getExportRecords,
        records,
        dryEye,
        0,
        "dryEye",
        function (type) {
          if (type) {
            callType = true;
            callback(callType);
          }
        }
      );
    } else if (!_this.hasDryeye && _this.hasTopograPhy) {
      _this.createNameIdFiles(
        patients,
        getExportRecords,
        records,
        topography,
        0,
        "topography",
        function (type) {
          if (type) {
            callType = true;
            callback(callType);
          }
        }
      );
    } else if (_this.hasDryeye && _this.hasTopograPhy) {
      this.createNameIdFiles(
        patients,
        getExportRecords,
        records,
        dryEye,
        0,
        "dryEye",
        function (type) {
          if (type) {
            _this.createNameIdFiles(
              patients,
              getExportRecords,
              records,
              topography,
              0,
              "topography",
              function (type) {
                if (type) {
                  callType = true;
                  callback(callType);
                }
              }
            );
          }
        }
      );
    } else {
      callType = true;
      callback(callType);
    }
  }

  //  递归新建 name 文件夹
  createNameIdFiles(patients, getExportRecords, records, dryToPath, num, recordType, callback) {
    if (num < patients.length) {
      let patient = patients[num];
      let childPath =
        dryToPath +
        "/" +
        (patient.firstname && patient.lastname
          ? patient.firstname.replace(/[\r\n]/g, "") + "_" + patient.lastname.replace(/[\r\n]/g, "")
          : patient.firstname.replace(/[\r\n]/g, "")) +
        "_" +
        patient.pid.toString().replace(/[\r\n]/g, "");
      fileSys.mkdirSync(childPath);
      if (fileSys.isFileExists(childPath)) {
        // 新建日期
        if (getExportRecords.length > 0) {
          this.createDateTimeFiles(childPath, patient._id, getExportRecords, 0, recordType);
        }
        num++;
        this.createNameIdFiles(
          patients,
          getExportRecords,
          records,
          dryToPath,
          num,
          recordType,
          callback
        );
      }
    } else {
      let FilesType = true;
      callback(FilesType);
    }
  }

  //  递归新建 date 文件夹
  createDateTimeFiles(childPath, patientId, getExportRecords, num, recordType) {
    if (num < getExportRecords.length) {
      var getRecord = getExportRecords[num];
      if (recordType === "dryEye" && getRecord.hasOwnProperty("eyetype")) {
        if (getRecord.patientid === patientId && getRecord.checktype === "dryeye") {
          this.mkdirCreateDate(getRecord, childPath, recordType);
        }
      } else if (recordType === "topography") {
        if (getRecord.patientid === patientId && getRecord.checktype === "topography") {
          this.mkdirCreateDate(getRecord, childPath, recordType);
        }
      }
      num++;
      this.createDateTimeFiles(childPath, patientId, getExportRecords, num, recordType);
    }
  }

  // 建立时间文件夹抽离
  mkdirCreateDate(getRecord, childPath, recordType) {
    var topographyReplace = getRecord.recorddate.replace(/\s+/g, "_");
    var topographyReplace2 = topographyReplace.replace(/[\s:]/g, "-");
    var childPath3 = childPath + "/" + topographyReplace2;
    // 删除子文件夹
    // if (fs.existsSync(childPath3)) {
    //   clearChildFiles(childPath3)
    // }
    fileSys.mkdirSync(childPath3);
    this.createOsOd(childPath3, getRecord, recordType);
  }

  // 建立 os od
  createOsOd(childPath3, getRecord, recordType) {
    callbackPath.osPath = path.join(childPath3 + "/" + arrOsOd[0], "/");
    callbackPath.odPath = path.join(childPath3 + "/" + arrOsOd[1], "/");
    for (var i = 0; i < arrOsOd.length; i++) {
      var osOdPath = childPath3 + "/" + arrOsOd[i];
      fileSys.mkdirSync(osOdPath);
      this.createChildFiles(osOdPath, getRecord, recordType, arrOsOd[i]);
    }
  }

  // 建立 干眼和角膜类型文件夹
  createChildFiles(osOdPath, getRecord, recordType, osOdType) {
    //  导出角膜原图 1代表干眼  2 代表 角膜
    if (recordType === "dryEye") {
      for (let i = 0; i < exportTypeImageVideo.length; i++) {
        let dPath = osOdPath + "/" + exportTypeImageVideo[i].value;
        fileSys.mkdirSync(dPath);
        this.exportRecordDetails(getRecord, exportTypeImageVideo[i].value, dPath, 0, osOdType, 1);
      }
    } else if (recordType === "topography") {
      for (let j = 0; j < exportTypeTopography.length; j++) {
        let tPath = osOdPath + "/" + exportTypeTopography[j];
        fileSys.mkdirSync(tPath);
        this.exportRecordDetails(getRecord, exportTypeTopography[j], tPath, 0, osOdType, 2);
      }
    }
  }

  // 导出数据,显示图片视频报告表格方法
  exportRecordDetails(getRecord, exportType, typePath, num, osOdType, topographyType) {
    // 1 2 代表 os od
    let _this = this;
    logStdout("exprot data record all details", recordAllDetails);
    if (num < recordAllDetails.length) {
      let details = recordAllDetails[num];
      let detailsEyeType = details.eyeType.split(",");
      if (getRecord._id === details._id) {
        if (details["data" + osOdType].diagnosed) {
          this.copyImageVideo(
            exportType,
            typePath,
            details["data" + osOdType],
            detailsEyeType[0] === "OS" ? 1 : 2,
            topographyType,
            osOdType,
            function (type) {
              if (type) {
                num++;
                _this.exportRecordDetails(
                  getRecord,
                  exportType,
                  typePath,
                  num,
                  osOdType,
                  topographyType
                );
              }
            }
          );
        }
      }
    }
  }

  // 拷贝图片和视频
  copyImageVideo(exportType, typePath, details, type, topographyType, osOdType, callback) {
    if (topographyType === 2) {
      // 拷贝角膜 原图
      let pathJoin = path.join(typePath, topographyOriginalObj.name);
      let originPupilImgPath = "";
      if (exportType === exportTypeTopography[0]) {
        originPupilImgPath = typePath;
        if (fileSys.isFileExists(topographyOriginalObj["cornea" + osOdType + "Img"])) {
          const cmd = `cp -rf ${topographyOriginalObj["cornea" + osOdType + "Img"]} ${pathJoin};sync`;
          exec(cmd, function (err) {
            if (err) {
              console.log(err);
            }
          });
        }
      }
      if (exportType === exportTypeTopography[1]) {
        if (
          topographyOriginalObj["pupil" + osOdType + "Img"] !== null ||
          topographyOriginalObj["pupil" + osOdType + "Img"] !== undefined
        ) {
          callbackTopographyImagePath = exportTypeTopography[1];
        } else {
          const type = true;
          callback(type);
        }
      }
      // 下载瞳孔图 原图
      if (originPupilImgPath) {
        download(
          topographyOriginalObj["pupil" + osOdType + "Img"],
          originPupilImgPath,
          topographyOriginalObj.pupilName,
          function (type) {
            if (type) {
              callback(type);
            }
          }
        );
      }
    } else {
      // 拷贝干眼
      let iv = [];
      logStdout("export data dryeye details", details);
      for (let obj in details) {
        if (exportType === obj) {
          if (details[obj].hasOwnProperty("down")) {
            let photos = details[obj].down.photos;
            for (let i = 0; i < photos.length; i++) {
              if (photos[i].mimetype === "image/jpeg") {
                if (photos[i].imagelabel === "original") {
                  iv.push({
                    originalname: photos[i].originalname,
                    filename: photos[i].filename
                  });
                }
              } else if (photos[i].mimetype === "video/mp4") {
                iv.push({
                  originalname: photos[i].originalname + ".mp4",
                  filename: photos[i].filename
                });
              }
            }
          }
          if (details[obj].hasOwnProperty("up")) {
            let photos = details[obj].up.photos;
            for (let i = 0; i < photos.length; i++) {
              if (photos[i].mimetype === "image/jpeg") {
                if (photos[i].imagelabel === "original") {
                  iv.push({
                    originalname: photos[i].originalname,
                    filename: photos[i].filename
                  });
                }
              } else if (photos[i].mimetype === "video/mp4") {
                iv.push({
                  originalname: photos[i].originalname,
                  filename: photos[i].filename
                });
              }
            }
          }
          if (!details[obj].hasOwnProperty("up") && !details[obj].hasOwnProperty("down")) {
            if (obj === "fbut") {
              for (let x = 0; x < details[obj].length; x++) {
                let photos = details[obj][x].photos;
                for (let i = 0; i < details[obj][x].photos.length; i++) {
                  if (photos[i].mimetype === "image/jpeg") {
                    if (photos[i].imagelabel === "original") {
                      iv.push({
                        originalname: photos[i].originalname,
                        filename: photos[i].filename
                      });
                    }
                  } else if (photos[i].mimetype === "video/mp4") {
                    iv.push({
                      originalname: photos[i].originalname,
                      filename: photos[i].filename
                    });
                  }
                }
              }
            } else {
              let photos = details[obj].photos;
              for (let i = 0; i < details[obj].photos.length; i++) {
                if (photos[i].mimetype === "image/jpeg") {
                  if (photos[i].imagelabel === "original") {
                    iv.push({
                      originalname: photos[i].originalname,
                      filename: photos[i].filename
                    });
                  }
                } else if (photos[i].mimetype === "video/mp4") {
                  iv.push({
                    originalname: photos[i].originalname,
                    filename: photos[i].filename
                  });
                }
              }
            }
          }
        }
      }
      if (iv.length > 0) {
        for (let i = 0; i < iv.length; i++) {
          for (let j = 0; j < this.getPathArr.length; j++) {
            if (iv[i].filename === this.getPathArr[j]) {
              copyArr.push({
                typePath: typePath,
                originalname: iv[i].originalname,
                getNowPath: this.getPathArr[j],
                suffix: iv.suffix
              });
            }
          }
        }
        const bool = true;
        callback(bool, typePath);
      } else {
        const bool = true;
        callback(bool, typePath);
      }
    }
  }

  // 递归干眼
  copyDryEye(num, callback) {
    let copyArrNum = copyArr[num];
    let _this = this;
    logStdout("export data copy array", copyArr.concat());
    if (num < Number(copyArr.length)) {
      let typePath = copyArrNum.typePath;
      let getNowPath = copyArrNum.getNowPath;
      let url1 = path.join(getMediaPath, getNowPath);
      let url2 = path.join(typePath, copyArrNum.originalname);
      fs.access(url1, function (err) {
        if (err === null && err !== undefined) {
          exec("cp -rf" + " " + url1 + " " + url2 + ";sync ", function (err) {
            if (!err) {
              num++;
              _this.copyDryEye(num, callback);
            }
          });
        } else {
          num++;
          _this.copyDryEye(num, callback);
        }
      });
    } else {
      const type = true;
      callback(type);
    }
  }

  getPathFun() {
    this.getPathArr = [];
    let files = [];
    let _this = this;
    if (fileSys.isFileExists(getMediaPath)) {
      files = fs.readdirSync(getMediaPath);
      files.forEach(function (file) {
        _this.getPathArr.push(file);
      });
    }
  }
  // 查询是否有文件
  mkdirFile(file) {
    fileSys.mkdirSync(file);
    // let hasPath = fs.existsSync(file)
    // console.log('hasPath', hasPath)
    // if (!hasPath) {
    //   fs.mkdirSync(file)
    // }
  }
  //   linux 压缩文件夹
  compressFile(file, callback) {
    let status = {
      type: false,
      fileName:
        moment(Math.round(new Date())).format("YYYY_MM_DD_HH_mm_ss") + "_" + "dea520Data.tar"
    };
    const name = `tar -cf ${file}/${status.fileName} ../../MwData/dea520/ 1>/dev/null 2>&1`;

    exec(name + "  ; sync", function (err) {
      console.log("err2", err);
      if (!err) {
        status.type = true;
        callback(status);
      }
    });
  }
  // 是否有移动设备
  hasUSB(newFile, callback) {
    const media = "df | grep /home/mw520/Udisk";
    exec(media, function (err, data) {
      if (!err) {
        const usb = data.replace(/(\n|\r\n)+/g, " ");
        // 只要第一个U盘
        usbName = usb.split(" ")[0];
      } else {
        usbName = false;
        console.log(err);
      }
      callback(usbName);
    });
  }
  // 拷贝文件至u 盘
  copyToUdisk(oldFilePath, newFilePath, copyfileName, callback) {
    let type = true;
    this.hasUSB(newFilePath, function (usbName) {
      const copy = `rsync -az ${oldFilePath}/${copyfileName} ${newFilePath}`;
      exec(copy, function (err, data) {
        console.log("u-", err);

        exec("sync", function () {
          console.log("err4", err);
          if (!err) {
            callback(type);
          } else {
            type = !(err.message.indexOf("Input/output error") >= 0);
            callback(type);
          }
        });
      });
    });
  }
  //  linux  清空文件
  clearFile(filePath, callback) {
    let type = false;
    // 如果拷贝成功则删除本地路径， 失败则再次拷贝本地文件无需再次压缩
    exec("rm -rf " + filePath + ";sync", function (err) {
      if (!err) {
        type = true;
        callback(type);
      } else {
        callback(type);
      }
    });
  }
  //   比对移动设备是否内存不足
  compare(file, UsbFile, fileName, callback) {
    let byte1;
    let byte2;
    let type = false;

    // 读文件
    exec("du -l " + file + "/" + fileName, function (err, data) {
      if (!err) {
        byte1 = data.split(/\s+/)[0];
        // 读优盘
        const path = "df | grep " + UsbFile;
        exec(path, function (err, data2) {
          if (!err) {
            byte2 = data2.split(/\s+/)[3];

            if (Number(byte2) > Number(byte1)) {
              type = true;
            }
            callback(type);
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    });
  }
}

// 下载图片至路径
var download = function (url, dir, filename, callback) {
  request.head(url, function (err) {
    if (!err) {
      request(url).pipe(fs.createWriteStream(dir + "/" + filename));
      const type = true;
      callback(type);
    }
  });
};

const exportFileData = new ExportData();
export default exportFileData;



// WEBPACK FOOTER //
// ./src/mainInterface/js/exportUserList.js